// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"438":"1706e794","966":"bbd0862f","984":"a05e013a"}[chunkId] + ".chunk.css";
};